// Dashboard color palette for consistent theming
export const DASHBOARD_COLORS = {
  // Primary colors
  primary: '#3182CE', // Blue
  secondary: '#38A169', // Green
  accent: '#805AD5', // Purple

  // Status colors
  success: '#38A169', // Green
  warning: '#DD6B20', // Orange
  error: '#E53E3E', // Red
  neutral: '#718096', // Gray

  // Chart specific colors
  whatsapp: '#38A169', // Green (consistent with WhatsApp brand)
  web: '#3182CE', // Blue

  // Sentiment colors
  positive: '#38A169', // Green
  negative: '#E53E3E', // Red

  // Gradients
  gradients: {
    blue: ['#3182CE', '#2B77CB'],
    green: ['#38A169', '#2F855A'],
    purple: ['#805AD5', '#6B46C1'],
    orange: ['#DD6B20', '#C05621'],
  },
} as const;

// ApexCharts color arrays for easy use
export const APEX_COLORS = {
  primary: [DASHBOARD_COLORS.primary, DASHBOARD_COLORS.secondary],
  sentiment: [
    DASHBOARD_COLORS.positive,
    DASHBOARD_COLORS.warning,
    DASHBOARD_COLORS.error,
  ],
  single: DASHBOARD_COLORS.primary,
};
